import i18n from '@/i18n';

export default [
  { value: 1, text: i18n.t('transport') },
  { value: 9, text: i18n.t('fuel') },
  { value: 5, text: i18n.t('fee') },
  { value: 6, text: i18n.t('service') },
  { value: 7, text: i18n.t('weight') },
  { value: 31, text: i18n.t('dimensions') },
  { value: 122, text: i18n.t('ldm') },
  { value: 123, text: i18n.t('circumference') },
]
